import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StockItem, StockItemSearchResult} from "../../../record/feature-print-models";
import {IdWithIndex} from "../default-customer.module";

@Component({
  selector: 'default-fp-list',
  templateUrl: './default-featureprint-list-view.component.html',
  styleUrls: ['./default-featureprint-list-view.component.scss']
})
export class DefaultFeatureprintListViewComponent {

  @Input() stockItems: StockItemSearchResult[] = [];
  @Input() currentStockItem: string | null = null;
  @Input() dataset: string | null = null;

  @Output() setStockItemEvent: EventEmitter<IdWithIndex> = new EventEmitter<IdWithIndex>();
}

